export default {
  init() {
    // JavaScript to be fired on the testimonials page
    $('.direction-items').accordion({
      heightStyle: 'content',
      animate: { 
        easing: 'swing', 
        duration: 400, 
      },
    });
  },
  finalize() {
    var L = window.L;

    var lat = $('#map-container').data('lat');
    var lng = $('#map-container').data('lng');
    var zoom = $('#map-container').data('zoom');
    var markers = $('#map-container').data('markers');

    var vigilantIcon = L.icon({
      iconUrl: '../wp-content/themes/vigilant/dist/images/marker-image.svg',

      iconSize:     [80, 57], // size of the icon
      iconAnchor:   [40, 57], // point of the icon which will correspond to marker's location
    });

    var map = L.map('map-container', {
      center: [lat, lng],
      zoom: zoom,
    });

    L.tileLayer('https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png?api_key=17623967-8779-40f1-b939-25a759b5603c', {
      maxZoom: 100,
      attribution: '',
    }).addTo(map);

    markers.forEach(marker => {
      L.marker([marker.lat, marker.lng], {icon: vigilantIcon}).addTo(map)
    });

    map.invalidateSize();

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js